import {Component} from '@angular/core';

@Component({
    selector: 'tfl-verify-check-icon',
    template: `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g fill="none" fill-rule="evenodd">
                <path d="M0 0L24 0 24 24 0 24z"/>
                <path fill="#4CAF50" fill-rule="nonzero" d="M12 5c-3.864 0-7 3.136-7 7s3.136 7 7 7 7-3.136 7-7-3.136-7-7-7zm-1.4 10.5L7.1 12l.987-.987 2.513 2.506 5.313-5.313.987.994-6.3 6.3z"/>
            </g>
        </svg>
    `
})
export class VerifyCheckIcon {
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/icons/verify.check.icon.ts